import { render, staticRenderFns } from "./ItemBarProfile.vue?vue&type=template&id=41edc7c6"
import script from "./ItemBarProfile.vue?vue&type=script&lang=js"
export * from "./ItemBarProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports